import { useState } from 'react';
import TranslationPageLayout from '../../Components/shared/TranslationPageLayout.js';
import CommonImage from '../../Components/shared/ImageComponent';
// import Footer from '../../Components/shared/Footer';
import { immigrationDocumentTranslationData } from '../../Components/shared/faqList';
import FAQ from '../../Components/shared/FAQ';
// import Navbar from '../../Components/shared/Header';
import { IMAGES } from "./imagesImports";
import {
    section2Images,
    section3Images,
    section5Images,
    section6Images,
    section7Images,
    section8Images,
    section10Images
} from "./imagesItem"
import { useHorizontalScroll } from "../../Hooks/useHorizontalScroll.js";
import HorizontleButtons from '../../Components/shared/HorizontleButtons.js';
import "./index.css"
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount';
import { useLocation } from 'react-router-dom';
import Navbar from '../HomePage/header.js';
import Footer from '../HomePage/footer.js';

const LegalDocumentTranslationPage = ({ windowSize }) => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
    
    const {
        scrollRef: section3ImmRef,
        scrollLeft: section3Left,
        scrollRight: section3Right,
    } = useHorizontalScroll(300);

    const {
        scrollRef: section6ImmRef,
        scrollLeft: section6Left,
        scrollRight: section6Right,
    } = useHorizontalScroll(300);

    const {
        scrollRef: section8ImmRef,
        scrollLeft: section8Left,
        scrollRight: section8Right,
    } = useHorizontalScroll(350);

    const handleLoginOpen = (newState) => {
        setIsModalOpen(newState);
    };

    const handleCreateAccountOpen = (newState) => {
        setIsCreateAccountOpen(newState);
    };

    return (
        <TranslationPageLayout>

            <SignInForm
                open={isModalOpen}
                isLoginFormOpen={handleLoginOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
            />
            <CreateAccount
                open={isCreateAccountOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
                isLoginFormOpen={handleLoginOpen}
            />

            {/* Hero section */}
            <div role='Hero-frame' className='legal-hero-frame w-full'>
                <div className='immigrationHero'>
                    <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen} border={true} />
                    <div role='content-section' className='immigration-contentSection'>
                        <div role='left-section' className='immigrationContentSectionLeft'>
                            <span className='immigration-combineLargeText immigration-largeText text-5xl md:text-6xl lg:text-[80px]'>Certified <span className='immigration-orange-text'>USCIS</span> Translations by <span className='immigration-green-text'>eVerbary</span></span>
                            <span className='immigration-smallText'>eVerbary provides professional immigration document translation services approved for United States Citizenship and Immigration Services (USCIS) submissions. Our certified translation team translates personal and legal documents into English with the precision and compliance required for immigration purposes.</span>
                        </div>
                        <div role='right-section' className='immigrationContentSectionRight border' >
                            <span className='immigrationContentSectionRightText'>If you need to translate documents for USCIS, such as a birth certificate, marriage certificate, or supporting documents for immigration applications, we offer accurate, fast, and guaranteed translation services. </span>
                            <CommonImage src={IMAGES.IMMIGRATION_IMG} alt='hero image' />
                        </div>
                    </div>
                    <div role='hero-bottom-section' className='immigration-heroBottomSection'>
                        Our USCIS-certified translation services follow the specific requirements outlined by state citizenship and immigration services, ensuring your documents are accepted.
                    </div>
                </div>
            </div>

            {/* Why You Need USCIS Certified Translation Services */}
            <div className='immigration-section2'>
                <div role='section2-header' className='immigration-section2Header'>
                    <span className='immigration-section2HeaderHeading'>Why You Need USCIS Certified Translation Services</span>
                    <span className='immigration-section2HeaderText'>USCIS requires certified translations for all official documents not originally written in English. These include personal documents like birth certificates, certificates of marriage, diplomas, and other records used for immigration applications.</span>
                </div>
                <div role="section2-Image" className="immigration-section2Images scrollbar-hide">
                    {section2Images.map((item, index) => (
                        <div
                            key={index}
                            style={{ backgroundImage: `url(${item?.src})` }}
                            className='immigration-section2ImageItem'
                        >
                            <div className='imm-sec2-text'>{item?.text}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* What Is a Certified Translation for USCIS? */}
            <div className='immigration-section3'>
                <div role='section3-header' className='immigration-section3Header'>
                    <div className='immigration-section3HeaderHeading'>What Is a Certified Translation for USCIS?</div>
                    <div className='immigration-section3HeaderText'>A certified translation for USCIS includes:</div>
                </div>
                <div ref={section3ImmRef} role="section3-Images" className="immigration-section3Images scrollbar-hide">
                    {section3Images?.map((item, index) => (
                        <div className="immigration-section3Image" key={index}>
                            <CommonImage src={item?.src} alt={item?.alt} width={40} height={40} />
                            <div className="immigration-imageBottomText">{item?.text}</div>
                        </div>
                    ))}
                </div>
                <HorizontleButtons
                    scrollLeft={section3Left}
                    scrollRight={section3Right}
                />
                <span role='section5-bottom-text' className='immigration-section3HBottomText'>Our certified translations include all required components for USCIS acceptance. We guarantee that the translation is approved for immigration purposes.</span>
            </div>

            {/* Wide Range of Documents We Translate */}
            <div className="immigration-section4">
                <div className="immigration-section4Content">
                    <div className="immigration-section4ContentHeading">Wide Range of Documents We Translate</div>
                    <div className="immigration-section4ContentText">We translate a wide range of documents for USCIS, including:</div>
                </div>
                <img className='' src={IMAGES.IMM_SEC4_MOBILEIMG} />
            </div>

            {/* Our Translation Process Is Always Straightforward */}
            <div className='immigration-section5'>
                <div role='section5-header' className='immigration-section5Header'>
                    <span className='immigration-section5HeaderHeading'>Our Translation Process Is Always Straightforward</span>
                    <span className='immigration-section5HeaderText'>Our translation process ensures every financial document translation is accurate and compliant:</span>
                </div>
                <div role='section6-Images-and-text' className='immigration-section5ImagesAndText'>
                    <div role="section6-Images" className="immigration-section5Images">
                        {section5Images?.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    maxWidth: windowSize.width < 640 ? '100%' : '248px',
                                    minHeight: windowSize.width < 640 ? '246px' : '372px',
                                    background : `${item?.backgroundColor}`
                                }}                                
                                className='immigration-section5ImageItem relative'
                            >
                                <img className='rounded-4xl sm:w-auto w-[200px]' src={item?.src} />
                                <div className='flex flex-col self-start mr-4 gap-1 absolute bottom-6'>
                                    <span className='imm-sec5-heading'>{item?.heading}</span>
                                    <span className='imm-sec5-desc'>{item?.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <span role='section6-Images-text' className='immigration-section5BottomText'>Our translation turnaround typically ranges from 12 to 24 hours depending on page count and document length. We also offer expedited service for urgent needs.</span>
                </div>
            </div>

            {/* Certified Translations for USCIS – What to Expect From Us*/}
            <div className='immigration-section6-container'>
                <div className='immigration-section6'>
                    <div role='section4-header' className='immigration-section6Header'>
                        <div className='immigration-section6HeaderHeading'>Certified Translations for USCIS – What to Expect From Us</div>
                        <div className='immigration-section6HeaderText'>Our certified translations for USCIS are handled by experienced translators who specialize in immigration document translation. We understand the importance of completeness, accuracy, and meeting formatting rules established by citizenship and immigration services.<br /> You can expect from us:</div>
                    </div>
                    <div ref={section6ImmRef} role="section4-Images" className="immigration-section6Images scrollbar-hide">
                        {section6Images?.map((item, idx) => (
                            <div key={idx} className="immigration-section6ImageItem">
                                <CommonImage src={item?.src} alt={item?.alt} width={48} height={48} />
                                <div className="birth-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section6Left}
                        scrollRight={section6Right}
                        type='blue'
                    />
                </div>
            </div>

            {/* Why USCIS Translation Services from eVerbary Stand Out */}
            <div className='immigration-section7'>
                <div className='immigration-section7Header' >
                    <span className='immigration-section7HeaderHeading'>Why USCIS Translation Services from eVerbary Stand Out</span>
                    <span className='immigration-section7HeaderText'>eVerbary is a professional translation agency trusted to deliver certified translation services for USCIS. We support thousands of immigration applicants each year with translation accuracy that meets every regulation.<br /> Why our clients trust us:</span>
                </div>
                <div className="immigration-section7Images">
                    {section7Images.map((item, idx) => (
                        <div key={idx} className="immigration-section7ImageItem">
                            <CommonImage src={item?.src} alt={item?.alt} width={idx === 2 ? 80 : 48}
                                height={idx === 2 ? 80 : 48} />
                            <div className="immigration-section7CardText">
                                {item?.text}
                            </div>
                        </div>
                    ))}
                    <span className='immigration-section7BottomText'>Translations are accepted by USCIS and other U.S. institutions. We provide certified translations with a USCIS acceptance guarantee.</span>
                </div>
                {/* </div> */}
            </div>

            {/* Translation Services for Immigration Applications */}
            <div className='immigration-section8-container'>
                <div className='immigration-section8'>
                    <div role='section7-header' className='immigration-section8Header'>
                        <div className='immigration-section8HeaderHeading'>Translation Services for Immigration Applications</div>
                        <div className='immigration-section8HeaderText'>eVerbary provides translation services for immigration that help people move forward with their lives. Whether you're applying for a green card, permanent residency, asylum, or another USCIS process, we handle your documents with precision.</div>
                    </div>
                    <div className='immigration-section8-card'>
                        <span>Our team includes professional translator or translation agency staff members trained in immigration terminology. We understand what USCIS requires and how to meet every translation requirement with confidence.</span>
                    </div>
                    <div ref={section8ImmRef} role="section7-Images" className="immigration-section8Images scrollbar-hide">
                        {section8Images?.map((item, idx) => (
                            <div key={idx} className="immigration-section8Image">
                                <CommonImage src={item?.src} alt={item?.alt} width={62} height={62} />
                                <div className="medical-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section8Left}
                        scrollRight={section8Right}
                    />
                </div>
            </div>

            {/* Translation Certification That Meets Every Standard */}
            <div className='immigration-section9-container bg-cover bg-center'>
                <div className='immigration-section9'>
                    <div className='immigration-section9Content'>
                        <span className='immigration-section9ContentHeading'>Translation Certification That Meets Every Standard</span>
                        <span className='immigration-section9ContentCenterText'>This guarantees that your document is an accurate translation and meets the expectations of USCIS-certified translation.</span>
                    </div>
                    <img className='immigration-section9-BgImg' src={IMAGES.IMM_SEC9_DESKTOP} />
                    <div className='immigration-section9-img'>
                        <CommonImage src={IMAGES.IMM_SEC9_MOBILE} style={{
                            maxWidth: '100%',
                            display: 'block',
                            backgroundSize: 'contain'
                        }} />
                    </div>
                </div>
            </div>

            {/* Timing and Translation Turnaround | Translation Pricing and Costs */}
            <div className='immigration-section10 scrollbar-hide'>
                {section10Images?.map((item, index) => (
                    <div key={index} className='immigration-section10-div' style={{ background: item?.background }}>
                        <div className='flex flex-col gap-3 pt-[45px] pl-[26px] pr-[37px] pb-4'>
                            <span className='immigration-section10-div-heading'>{item?.heading}</span>
                            <p
                                style={{ maxWidth: item?.textWidth, alignSelf: "flex-start", }}
                                className='immigration-section10-div-desc'
                                dangerouslySetInnerHTML={{ __html: item.desc }}
                            />
                        </div>
                        <img
                            src={item?.src}
                            className={`w-[200px] sm:w-[250px] md:w-[${item?.width}px]`}
                        />
                    </div>
                ))}
            </div>

            {/* What Documents Need Certified Translations? */}
            <div className="gap-24 immigration-section11">
                <div className="immigration-section11Content">
                    <div className="immigration-section11ContentHeading">What Documents Need Certified Translations?</div>
                    <div className="immigration-section11ContentText">If you're preparing documents for USCIS, the following documents often require a certified translation:</div>
                </div>
                <CommonImage src={IMAGES.IMM_SEC11_IMG} alt="section_11_image" />
            </div>

            {/* FAQ */}
            <FAQ id='faqs-legal' faqData={immigrationDocumentTranslationData} />

            {/* Trust eVerbary for USCIS Document Translation Services */}
            <div className='immigration-section13'>
                <div className='imm-section13Heading'>Trust <span>eVerbary</span> for <span>USCIS Document<br /></span> <span>Translation Services</span></div>
                <div className='imm-section13TextOne'>eVerbary helps you navigate the translation requirements for USCIS with confidence. We deliver certified translations that are accurate, complete, and ready for submission.</div>
                <div className='imm-section13TextTwo'>Our translation team ensures your immigration documents are properly handled and translated by certified professionals. When timing matters, and acceptance is non-negotiable, we deliver.
                    Translate and certify your immigration documents today. Get a certified translation from a provider with proven experience in document translation services for USCIS.
                </div>
            </div>

            {/* Footer */}
            <Footer windowSize={windowSize} />
        </TranslationPageLayout >
    )
}

export default LegalDocumentTranslationPage